// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-msme-list',
//   templateUrl: './msme-list.component.html',
//   styleUrls: ['./msme-list.component.scss']
// })
// export class MsmeListComponent {

// }
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject, from } from "rxjs";
import { takeUntil, finalize, switchMap } from "rxjs/operators";
import { Table } from "primeng/table";

import { ApiServiceService } from "src/app/api-service.service";
import { AppUtility } from "src/app/interceptor/apputitlity";

@Component({
  selector: 'app-msme-list',
  templateUrl: './msme-list.component.html',
  styleUrls: ['./msme-list.component.scss']
})
export class MsmeListComponent {

  @ViewChild("dt") table!: Table;

  msmeRecords: any[] = [];
  filterval: string = "";
  vendorId: string = "";
  msmeError: string = "";
  isLoading: boolean = false;

  readonly breadcrumb = [
    { title: "MSME Supplier List", subTitle: "Dashboard" },
  ];

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly _apiService: ApiServiceService,
    private readonly _utility: AppUtility,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        takeUntil(this.destroy$),
        switchMap((params) => {
          this.vendorId = params["Id"] ?? params["id"] ?? "";
          return this.fetchMsmeList();
        })
      )
      .subscribe({
        next: (records) => {
          this.msmeRecords = records;
          if (records.length === 0) {
            this.msmeError = "No MSME records found.";
          }
        },
        error: (err) => {
          console.error("MSME list fetch error:", err);
          this.msmeError = "Failed to load MSME records. Please try again.";
          this._apiService.showMessage(this.msmeError, "error");
          this.isLoading = false;
        },
      });
  }

  /**
   * Wraps the Promise-based API call as an Observable so it participates
   * fully in the RxJS pipeline (cancellable, composable, consistent).
   */
  private fetchMsmeList() {
    this.isLoading = true;
    this.msmeError = "";
    this.msmeRecords = [];

    const request$ = from(
      this._apiService.getMsmeForms({ vendorId: this.vendorId })
    );

    return request$.pipe(
      takeUntil(this.destroy$),
      finalize(() => (this.isLoading = false)),
      switchMap((res: any) => {
        if (!res?.success) {
          const msg = res?.message ?? "Failed to load MSME records.";
          this._apiService.showMessage(msg, "error");
          throw new Error(msg);
        }
        const data = res.returnValue;
        const records: any[] = Array.isArray(data)
          ? data
          : data
          ? [data]
          : [];
        return [records];
      })
    );
  }

  // ── Document helpers ────────────────────────────────────────────────────────

  /** Extracts the filename from a file path (handles both / and \ separators). */
  getDocumentName(path: string, maxLength: number = 20): string {
  if (!path) return "";
  const name = path.split(/[\\/]/).pop() ?? path;
  if (name.length <= maxLength) return name;

  const ext = name.includes(".") ? "." + name.split(".").pop() : "";
  const base = name.slice(0, name.lastIndexOf("."));
  return base.slice(0, maxLength - ext.length - 3) + "..." + ext;
}

  /** Returns true if the path points to a common image format. */
  isImage(path: string): boolean {
    if (!path) return false;
    const ext = path.split(".").pop()?.toLowerCase() ?? "";
    return ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(ext);
  }

  // ── Table helpers ───────────────────────────────────────────────────────────

  getInputValue(event: Event): string {
    return (event.target as HTMLInputElement).value;
  }

  onFilter(event: Event, field: string): void {
    this.table.filter(this.getInputValue(event), field, "contains");
  }

  reset(): void {
    this.filterval = "";
    this.table?.reset();
  }

  // ───────────────────────────────────────────────────────────────────────────

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
